import React, {useMemo} from "react";
import {TitleLayout} from "~/apps/core/ui/TitleLayout";
import {
    Box, Card, CardContent,
    Grid, SvgIcon, Typography,
} from "@mui/material";
import {useTariffAgreements} from "~/apps/packages/finance/hooks";
import {LoadingResult} from "~/apps/core/ui/LoadingResult";
import {FileCard} from "~/apps/core/ui/FileCard";
import {ErrorBlock} from "~/components/ErrorBlocks/ErrorBlock";
import {LoadingBox} from "~/apps/core/ui/LoadingBox";


export const TariffsPage = () => {
    const {data, loading} = useTariffAgreements();
    const dataGroupByTitle = useMemo(() => {
        const groups = new Map<string, typeof data>();
        const order = ["Типовые соглашения", "Индивидуальные соглашения"];
        data?.forEach(item => {
            const title = item.typical ? "Типовые соглашения" : "Индивидуальные соглашения"
            if (!groups.has(title)) {
                groups.set(title, []);
            }
            groups.get(title).push(item);
        })
        return [...groups].sort((a, b) => order.indexOf(a[0]) - order.indexOf(b[0]));
    }, [data])

    return (
        <TitleLayout title={"Тарифы"}>
            <LoadingBox loading={loading}>
                {data && (
                    <Grid container direction="column" rowSpacing="8px" wrap="nowrap" marginTop={1} marginBottom={1}>
                        {dataGroupByTitle.map(([title, items]) => (
                            <>
                                <Grid item>
                                    <Typography variant="screenText" color="primary">
                                        {title}
                                    </Typography>
                                </Grid>
                                <Grid item>
                                    <Card>
                                        <CardContent>
                                            <Grid container direction="column" rowSpacing="10px" wrap="nowrap">
                                                {items.map(item => (
                                                    <Grid item key={item.id}>
                                                        <FileCard
                                                            type="download"
                                                            name={item.number || "Безномерной"}
                                                            uri={item.fileLink}
                                                            format="PDF"
                                                        />
                                                    </Grid>
                                                ))}
                                            </Grid>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            </>
                        ))}
                    </Grid>
                )}
                {data && data.length == 0 && (
                    <Box position="absolute" top="0" bottom="0" left="0" right="0">
                        <ErrorBlock
                            title="Нет действующих соглашений"
                            icon={(
                                <SvgIcon width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M26.9392 16.9693C23.3919 16.9693 20.5 19.8614 20.5 23.4087C20.5 26.956 23.3919 29.8482 26.9392 29.8482C28.4413 29.8482 29.8229 29.3251 30.9203 28.4579L36.6307 34.1709C36.9265 34.4674 37.4066 34.4682 37.7032 34.1727C37.9999 33.8771 38.0007 33.397 37.7049 33.1002L31.9915 27.3867C32.8574 26.2896 33.3794 24.9096 33.3794 23.4087C33.3794 19.8614 30.4865 16.9692 26.9392 16.9692L26.9392 16.9693ZM26.9392 18.4846C29.6677 18.4846 31.8636 20.6802 31.8636 23.4087C31.8636 26.1373 29.6677 28.3329 26.9392 28.3329C24.2106 28.3329 22.0158 26.1373 22.0158 23.4087C22.0158 20.6802 24.2107 18.4846 26.9392 18.4846Z" fill="#6E798C"/>
                                    <path d="M10.5 11.6665V13.3332H23.3792V11.6665H10.5Z" fill="#6E798C"/>
                                    <path d="M10.5 16.6665V18.3332H18.8333V16.6665H10.5Z" fill="#6E798C"/>
                                    <path d="M10.5 21.6665V23.3332H17.1667V21.6665H10.5Z" fill="#6E798C"/>
                                    <path d="M10.5 26.6665V28.3332H17.1667V26.6665H10.5Z" fill="#6E798C"/>
                                    <path fillRule="evenodd" clipRule="evenodd" d="M27.5588 4.99992H8.44118C7.62899 4.99992 6.97059 5.74611 6.97059 6.66659V33.3333C6.97059 34.2537 7.62899 34.9999 8.44118 34.9999H27.5588C28.371 34.9999 29.0294 34.2537 29.0294 33.3333V31.6666V19.9999V14.9999V6.66659C29.0294 5.74611 28.371 4.99992 27.5588 4.99992ZM8.44118 3.33325C6.81681 3.33325 5.5 4.82564 5.5 6.66659V33.3333C5.5 35.1742 6.81681 36.6666 8.44118 36.6666H27.5588C29.1832 36.6666 30.5 35.1742 30.5 33.3333V31.6666H29.0294V14.9999H30.5V6.66659C30.5 4.82564 29.1832 3.33325 27.5588 3.33325H8.44118Z" fill="#6E798C"/>
                                </SvgIcon>
                        )}>
                            Обратитесь к персональному менеджеру
                        </ErrorBlock>
                    </Box>
                )}
            </LoadingBox>
        </TitleLayout>
    );
}
